module.exports = __webpack_public_path__ + "img/cases-brand-avic-16.02259e85.jpg";